
import React from "react";
import DataTable from "react-data-table-component";
import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
} from "@mui/material";
import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';
import "../../listings/Listing.css";
import {
    getBillingFileData,
    getBillingReportsData,
} from "../../common/constants/globalconstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import ErrorModal from "../../common/ErrorModal";
import axiosInstance from "../../common/AxiosInterceptor";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { billReportColumns } from "./BillReportColumns";
import { getFormattedDate } from "../../common/Utils";

const customStyle = {
    table: {
      style: {
        border: "1px solid #DEDEDE",
        borderRadius: "5px",
        justifyContent: "center",
        marginBottom: "10px",
        marginTop: "10px",
      },
    },
    header: {
      style: {
        color: "#193062",
      },
    },
    headRow: {
      style: {
        border: "none",
        backgroundColor: "#CDD4DC",
        fontWeight: "bold",
        color: "#002d82",
        fontSize: "14px",
        whiteSpace: "unset",
      },
    },
    rows: {
      stripedStyle: {
        backgroundColor: "#F2F3F5",
        justifyContent: "center",
      },
    },
  };

function BillingReport() {
  const [loading, setloading] = useState(false); 
  const startDte = dayjs().startOf("year");
  const endDte = dayjs().endOf("year").startOf("day");
  const [startDate, setStartDate] = useState(startDte); 
  const [endDate, setEndDate] = useState(endDte); 
  const [billReportData, setBillReportData]= useState([]);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [isErr, setIsErr] =useState(false);
  const [resetPagination, setRstPagination] = useState(false); 
  const [tableKey, setTableKey] = useState(0);
  const [err, setErr] = useState("");

  useEffect(()=>{
    getBillingFiles(startDate, endDate);  
  },[]);

  const getBillingFiles = async(startDt, endDt) =>{
     try {
      setloading(true);
      const request={
        "startDate": getFormattedDate(startDt),
        "endDate": getFormattedDate(endDt)
      }
    const response = await axiosInstance.post(`${getBillingReportsData}`,JSON.stringify(request));
        if(response.data.isSuccess){
           setBillReportData(response.data.result);
           setTableKey(prevKey=> prevKey+1);
           seterrormodalOpen(false);
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    }
  }

  const handleDownlodLinkClick=(row, props)=>{
    getDownloadContent(row);
    }
  
  const getDownloadContent= async( row) =>{
      try {
        setloading(true);
        const response = await axiosInstance.get(`${getBillingFileData}?id=${row.id}`)
          if(response.data){
            const parsedJson = JSON.parse(response.data.result);
            //const stringifiedJson = JSON.stringify(parsedJson);
            exportToExcel(parsedJson, row.billingFileName);
          }
          else if(!response.data.isSuccess){
            seterrormodalOpen(true);
          }
          setloading(false);
      } catch (error) {
        console.log(error.message);
        seterrormodalOpen(true);
        setloading(false);
      }
    }

  const exportToExcel = async (data, filename)=> {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  if (data.length > 0) {
    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);
  }
  data.forEach(item => {
    const rowValues = Object.values(item);
    worksheet.addRow(rowValues);
  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, filename);
}


  const handleReset = () =>{
      const defaultStartDt = dayjs().startOf("year");
      const defaultEndDt = dayjs().endOf("year").startOf("day");
      setStartDate(defaultStartDt);
      setEndDate(defaultEndDt);
      getBillingFiles(defaultStartDt, defaultEndDt);
      setErr("");
      setIsErr(false);
      setRstPagination(!resetPagination);
      setTableKey(prevKey =>prevKey+1);
    }

  const validate = () =>{
    let errFlag = false;
    if(startDate && endDate && (endDate.isBefore(startDate) || startDate.isAfter(endDate))){
      setErr("Start Date should be less than End Date");
      setIsErr(true);
      return true;
    }
    else if(startDate && endDate && (startDate.isSame(endDate, 'year') && startDate.isSame(endDate, 'month'))){
      setErr("Start Date and End Date should not be same");
      setIsErr(true);
      return true;
    }
    return errFlag;
  }

    const handleSearch=() =>{
      if(!validate()){
        setErr("");
        setIsErr("");
        getBillingFiles(startDate, endDate);
        setRstPagination(!resetPagination);
      }
    }

      return (
        <div>
          {loading && (
            <>
              <Backdrop
                sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={true}
              >
                <CircularProgress sx={{ color: "white" }} />
                <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
              </Backdrop>
            </>
          )}
    
        <div>
          <Box
        sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
          left: "1%",
          right: "2%",
          flexDirection: "column",
          width: "97%",
          marginTop: "10px",
          marginBottom: "10px",
          alignItems: "center",
          p: "0% 1%",
          backgroundColor: "#fcfcfc",
          //border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
          <h2 className="header">Weiland Billing Report</h2>
         
            <div
                         style={{
                           display: "flex",
                           flexDirection: "row",
                         }}
                       >  
                     <Grid container>
                       <Box
                       sx={{height: "12px", width:"100%", color:"red", textAlign:"center"}}>
                         <p>{isErr && err ? err : ""}</p>
                       </Box>
                     <div style={{marginTop: "15px", width:"99%", marginRight:"18px"}}>              
                             <Box
                             sx={{
                               border:"1px solid #002d82",
                               position:"relative",
                               display:"inline-block",
                               barderRadius:"5px",
                               width: "100%",
                               padding:"8px",
                               //marginRight:"8px"
                             }}>
                                <Box
                                 display="flex"
                                 direction="row"
                                 alignItems="left"
                                 justifyContent="left"
                                 alignContent="left"
                                 columnGap="0.5rem"
                                 sx={{ width:"100%", height: "50px", m: "3px 0", marginTop:"5px" }} 
                             >
                          
                            <Grid xs={3.5}>
                             <Box
                               display="flex"
                               sx={{
                                 flexDirection: "row",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 alignContent: "center",
                                 height: "50px",
                                 fontSize: "15px"
                               }}
                             > 
                             
                               <p style={{width: "130px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
                                Start Date:</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                               
                                <DatePicker
                                className="report-to-datePicker"
                                sx={{ ml: "0px", width: "200px", marginBottom:"30px", marginRight:"10px", "& .MuiInputBase-input":{ height: "7px !important"} }}
                                //label="Start Date"
                                views={['month', 'year']} 
                                name="startDate"
                                onChange={(newValue)=> 
                                    setStartDate(newValue)
                                }
                                value={dayjs(startDate)}
                                size="small"
                                disableOpenOnEnter
                                />
                                </LocalizationProvider>
                             
                            </Box>
                            </Grid>
                            <Grid xs={3.5}>
                             <Box
                               display="flex"
                               sx={{
                                 flexDirection: "row",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 alignContent: "center",
                                 height: "50px",
                                 fontSize: "15px"
                 
                               }}
                             > 
                             <p style={{width: "130px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
                                End Date:</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker 
                                className="report-to-datePicker"
                                sx={{ ml: "0px", width: "200px", marginBottom:"30px", marginRight:"10px", "& .MuiInputBase-input":{ height: "7px !important"} }}
                                //label="End Date"
                                views={['month', 'year']} 
                                name="endDate"
                                onChange={(newValue)=> 
                                    setEndDate(newValue)
                                }
                                value={dayjs(endDate)}
                                size="small"
                                disableOpenOnEnter
                                />
                            </LocalizationProvider>
                             
                             </Box> 
                             </Grid>
                              
                             <Grid xs={3}>
                             <Box
                               display="flex"
                               sx={{
                                 flexDirection: "row",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 alignContent: "center",
                                 height: "50px",
                                 fontSize: "15px",
                                 columnGap: "1rem"
                               }}
                             > 
                             <Button
                               sx={{marginBottom:"15px"}}
                               variant="contained"
                               style={{ backgroundColor:"#002d82",width: "110px", height:"35px", marginLeft: "0.5rem", marginTop:"10px"}}
                               onClick={handleSearch}
                               >
                               Search
                               </Button>
                       
                               <Button
                               sx={{marginBottom:"15px"}}
                               variant="contained"
                               style={{ backgroundColor:"#002d82",width: "110px", height:"35px", marginTop:"10px"}}
                               onClick={handleReset}
                               >
                               Reset
                            </Button> 
                             
                             </Box> 
                             </Grid>
                             </Box> 
                                 
                             <Box
                             component="span"
                             sx={{ 
                               position: "absolute",
                               top: "-12px",
                               left:"15px",
                               //transform:"translateX(-50%)",
                               backgroundColor: "white",
                               padding: "0 10px",
                               fontSize:"14px",
                               whiteSpace:"nowrap"
                               }}
                                 >
                                  Filter Criteria:   
                                       
                             </Box>
                             </Box>
                     </div>
                     </Grid>    
                     </div> 
          
            <DataTable
              title=""
              key={tableKey}
              columns={billReportColumns(handleDownlodLinkClick)}
              data={billReportData}
              pagination
              striped
              highlightOnHover
              customStyles={customStyle}
              defaultSortFieldId={null}
              defaultSortAsc={null}
              paginationRowsPerPageOptions={[5, 10, 15, 20]}
              paginationResetDefaultPage={resetPagination}
              paginationPerPage={5}
              paginationComponentOptions={{
                rowsPerPageText: "Records per page",
                rangeSeparatorText: "Out of",
              }}
            />
            </Box>
          </div>
          {errormodalopen && (
            <ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
          )}
        </div>
      );
}

export default BillingReport;
